module.exports = __webpack_public_path__ + "static/media/fz_verifylocalsuccess_pt_BR.a0b926c2.png";